import * as React from "react";
import styled from "styled-components";
import { Box, Column, Columns } from "@origin-digital/ods-core";
import { Button, Text, TextAreaField } from "@origin-digital/style-guide";
import content from "../../cms/feedbackButtons.json";

const StyledLabel = styled.label`
  float: left;
  padding: 7px 16px;
  margin-right: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey500};
  text-align: center;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

const StyledInput = styled.input`
  display: none;
`;

const StyledButton = styled(Button)`
  margin-top: -16px;
`;

interface IProps {
  isSent: boolean;
  isHelpful: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onYesClick: () => void;
  onNoClick: () => void;
  onSubmit: () => Promise<void>;
  feedBackTextEnabled: boolean;
}

export const FeedbackButtons = (props: IProps) => {
  const {
    isSent,
    isHelpful,
    onChange,
    onYesClick,
    onNoClick,
    onSubmit,
    feedBackTextEnabled,
  } = props;

  return (
    <>
      <Columns space="large" alignY="center">
        <Column width="content">
          <Text fontWeight="medium" data-id="feedback-label">
            {isSent ? content.label.sent : content.label[isHelpful]}
          </Text>
        </Column>
        <Column width="content">
          {isHelpful === "default" && (
            <>
              <StyledInput
                type="radio"
                name="helpful"
                id="yes"
                value="yes"
                onClick={onYesClick}
              />
              <StyledLabel htmlFor="yes" data-id="yes">
                <Text size="sm" fontWeight="medium">
                  {content.button.yes}
                </Text>
              </StyledLabel>
              <StyledInput
                type="radio"
                name="helpful"
                id="no"
                value="no"
                onClick={onNoClick}
              />
              <StyledLabel htmlFor="no" data-id="no">
                <Text size="sm" fontWeight="medium">
                  {content.button.no}
                </Text>
              </StyledLabel>
            </>
          )}
        </Column>
      </Columns>
      {feedBackTextEnabled && isHelpful === "no" && !isSent && (
        <Box marginTop="xlarge">
          <TextAreaField
            name="feedback"
            label={content.feedbackResponse.label}
            height={180}
            maxLength={180}
            onChange={onChange}
            data-id="feedback"
          />
          <StyledButton
            type="submit"
            text={content.feedbackResponse.submit}
            small={true}
            data-id="feedbackSubmitBtn"
            onClick={onSubmit}
          />
        </Box>
      )}
    </>
  );
};
